import clsx from "clsx";
import "./DoctorConfirmModalContent.scss";

type DoctorConfirmModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const DoctorConfirmModalContent = ({
  overrideClassNames,
  children,
}: DoctorConfirmModalContentProps) => {
  return (
    <div className={clsx("ui-consent-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
